import React, { Component } from 'react'
import Keen from 'keen-js'
import { object, string } from 'prop-types'

// utils
import { createQuery, runQuery, createQueryCTA } from '../../../utils/KeenReport'

// components
import Spinner from '../../Spinner'
import CompleteFunnelGraph from '../CompleteFunnelGraph'

class CompleteFunnelChart extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isLoading: true,
      hasError: false,
      recommends: 'Carregando...',
      plays: 'Carregando...',
      playrate: 'Carregando...'
    }

    this.runKeen = this.runKeen.bind(this)
    this.prepareDataToGraph = this.prepareDataToGraph.bind(this)
    this.toggleVideoPlay = this.toggleVideoPlay.bind(this)
  }
  componentDidMount () {
    this.runKeen(this.props)
  }
  componentWillReceiveProps (nextProps) {
    if (nextProps.timeframe !== this.props.timeframe) {
      this.runKeen(nextProps)
    }
  }
  toggleVideoPlay (hasVideoPlay) {
    this.setState({
      hasVideoPlay
    }, () => { this.prepareDataToGraph() })
  }
  prepareDataToGraph () {
    const { video } = this.props
    let { recommendations, plays, videoPlays, navGroup, conversions, hasVideoPlay } = this.state
    let dataForGraph = [
      { label: 'Recomendações', value: recommendations, type: 'line', rate: 1 },
      { label: 'Plays', value: plays, type: 'line', rate: (plays / recommendations) }
    ]

    // nav
    let line = { label: 'Navegaçao', values: [], type: 'nav-group', color: '#42b3f4' }
    let total = 0
    navGroup.forEach((nav) => {
      line.values.push({
        label: nav[video.nav_filter_group_by],
        value: nav.result
      })

      total += nav.result
    })

    // calcuando distribuicao POR nav
    line.values.forEach((nav) => {
      nav.rate = nav.value / total
    })

    if (hasVideoPlay) {
      dataForGraph.push({ label: 'Player tocar video', value: videoPlays, type: 'line', color: '#ad48a1', rate: (videoPlays / plays) })
      line.rate = total / videoPlays
      dataForGraph.push(line)
      // cta
      dataForGraph.push({ label: 'Conversão', value: conversions, type: 'line', color: '#2CA02C', rate: (conversions / videoPlays) })
    } else {
      line.rate = total / plays
      dataForGraph.push(line)
      // cta
      dataForGraph.push({ label: 'Conversão', value: conversions, type: 'line', color: '#2CA02C', rate: (conversions / plays) })
    }

    this.setState({
      isLoading: false,
      hasError: false,
      dataForGraph
    })
  }
  runKeen (props) {
    Keen.ready(() => {
      let { campaign, actor, timeframe, video, filters } = props
      let queries

      this.setState({
        isLoading: true,
        hasError: false
      })
      if (actor === 'pessoas') {
        queries = [
          createQuery('count_unique', 'video_recomended', timeframe, campaign, video, 'client_viewer_id', null, filters),
          createQuery('count_unique', 'video_unique_click', timeframe, campaign, video, 'client_viewer_id', null, filters),
          createQuery('count_unique', 'video_unique_play', timeframe, campaign, video.player_video_id, 'client_viewer_id', null, filters),
          createQueryCTA('count_unique', 'user_interacted', timeframe, campaign, video, 'client_viewer_id', null, [...video.nav_filter, ...filters], video.nav_filter_group_by),
          createQueryCTA('count_unique', 'user_interacted', timeframe, campaign, video, 'client_viewer_id', null, [...video.conversion_filter, ...filters])
        ]
      } else {
        queries = [
          createQuery('count', 'video_recomended', timeframe, campaign, video, null, null, filters),
          createQuery('count', 'video_unique_click', timeframe, campaign, video, null, null, filters),
          createQuery('count', 'video_unique_play', timeframe, campaign, video.player_video_id, null, null, filters),
          createQueryCTA('count', 'user_interacted', timeframe, campaign, video, null, null, [...video.nav_filter, ...filters], video.nav_filter_group_by),
          createQueryCTA('count', 'user_interacted', timeframe, campaign, video, null, null, [...video.conversion_filter, ...filters])
        ]
      }
      runQuery(queries)
        .then((res) => {
          this.setState({
            recommendations: res[0].result,
            plays: res[1].result,
            videoPlays: res[2].result,
            navGroup: res[3].result,
            conversions: res[4].result
          }, () => { this.prepareDataToGraph() })
        }, (err) => {
          console.log('Erro rodando a query do Keen.', err)
          this.setState({
            hasError: true
          })
        })
    })
  }
  render () {
    let { isLoading, hasError } = this.state
    return (
      <div>
        <div className={isLoading ? 'hidden' : ''}>
          <CompleteFunnelGraph
            dataForGraph={this.state.dataForGraph}
            toggleVideoPlay={this.toggleVideoPlay}
          />
        </div>
        <Spinner isLoading={isLoading} hasError={hasError} runKeen={() => { this.runKeen(this.props) }} />
      </div>
    )
  }
}

CompleteFunnelChart.propTypes = {
  timeframe: object,
  campaign: object,
  actor: string,
  video: object
}

export default CompleteFunnelChart



// WEBPACK FOOTER //
// ./src/components/charts/Funnels/SimpleNavFunnel.js